import { render, staticRenderFns } from "./EditProgramPage.vue?vue&type=template&id=e992c798&scoped=true&"
import script from "./EditProgramPage.vue?vue&type=script&lang=js&"
export * from "./EditProgramPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e992c798",
  null
  
)

export default component.exports